import PropTypes from "prop-types"
import React from "react"

import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"

//Simple bar
import SimpleBar from "simplebar-react"

import SidebarContent from "components/VerticalLayout/Sidebar-Menu"

const Sidebar = props => {
  const isFilterRoute = props.location.pathname === "/dashboard-padrao" ||
    props.location.pathname === "/notas-emitidas" ||
    props.location.pathname === "/movimento-vendas"
  const hasExtraHeader = isFilterRoute && window.innerWidth < 992

  return (
    <React.Fragment>
      <div className="vertical-menu" style={hasExtraHeader ? { paddingTop: '128px' } : undefined}>
        <div data-simplebar className="h-100">
          { props.type !== "condensed" ? (
            <SimpleBar style={ { maxHeight: "100%" } }>
              <SidebarContent />
            </SimpleBar>
          ) : (
            <SidebarContent />
          ) }
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter((Sidebar)))
